import React, { useEffect, useRef, useState } from 'react';

import '@toast-ui/editor/dist/toastui-editor.css';
import '@toast-ui/editor/dist/i18n/ko-kr';
import { Editor } from '@toast-ui/react-editor';
import colorSyntax from '@toast-ui/editor-plugin-color-syntax';
import 'tui-color-picker/dist/tui-color-picker.css';
import '@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useRecoilValue } from 'recoil';
import { authAtom } from '_state';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { authUtils } from '../../utils/authUtils';
import Dropzone from '../../components/Inputs/Dropzone';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import DateAdapter from '@mui/lab/AdapterMoment';
import DatePicker from '@mui/lab/DatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import Stack from '@mui/material/Stack';

const columns = [{ id: 'fileName', label: '첨부파일', minWidth: 40, width: 400, align: 'left' }];

export default function Register(props) {
  const { state } = props;
  const [datas, setDatas] = useState({});
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    setError,
    formState: { errors, isDirty }
  } = useForm({});

  const auth = useRecoilValue(authAtom);

  const navigate = useNavigate();
  const location = useLocation();
  const { name, kind, id, file } = location.state;
  const editorRef = useRef();
  let formData = new FormData();

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleBack = () => {
    navigate(-1);
  };

  const handleChange = (e) => {
    setDatas({ ...datas, [e.target.id]: e.target.value });
  };

  const registerOrModify = async (formData, config) => {
    if (state === 'register' || state === 'reply') return await registerBoard(formData, config);
    return await modifyBoard(formData, config);
  };

  const registerBoard = async (formData, config) => {
    return await axios.post(`/api/board`, formData, config);
  };

  const modifyBoard = async (formData, config) => {
    return await axios.patch(`/api/board/${kind}/${datas.id}`, formData, config);
  };

  const onSubmit = (data) => {
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    };
    formData.append('state', state);
    formData.append('kind', kind);
    formData.append('createdId', auth.userid);
    formData.append('subject', datas.subject);
    formData.append('content', editorRef.current?.getInstance().getHTML());
    formData.append('isSecret', datas.isSecret);
    formData.append('isNotice', datas.isNotice);
    formData.append('startDate', startDate);
    formData.append('endDate', endDate);
    if (state === 'reply') {
      formData.append('parentId', id);
    }

    config.headers['Content-Length'] = editorRef.current?.getInstance().getHTML().length;

    registerOrModify(formData, config)
      .then((response) => {
        alert(response.data.message);
        navigate(`/${response.data.kind}`);
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const handleFileDelete = (fileId) => {
    axios
      .delete(`/api/board/file/${fileId}`)
      .then((response) => {
        alert(response.data.message);
        axios.get(`/api/board/${kind}/${id}`).then((response) => {
          setDatas({ ...datas, files: response.data.files });
        });
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const getBoardDetail = async () => {
    const response = await axios.get(`/api/board/${kind}/${id}`);
    await setDatas(response.data);
    await setStartDate(response.data.startDate);
    await setEndDate(response.data.endDate);
    await setValue('datas', response.data);

    const htmlToEditor = response.data?.content;
    editorRef.current?.getInstance().setHTML(htmlToEditor);
  };

  const handleChangeCheckbox = (e) => {
    setDatas({ ...datas, [e.target.name]: e.target.checked });
  };

  useEffect(async () => {
    if (state === 'modify') {
      await getBoardDetail();
    }
  }, []);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        {name} {state === 'register' ? '등록' : state === 'modify' ? '수정' : '답글'}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1 }}>
            <TextField
              id="subject"
              variant="outlined"
              label="제목"
              sx={{ width: 3.5 / 5, ml: 1 }}
              value={datas?.subject || ''}
              error={!!errors.datas?.subject}
              helperText={errors.datas?.subject && errors.datas?.subject.message}
              {...register('datas.subject', {
                required: '제목을 입력해주세요.',
                maxLength: { value: 200, message: '제목은 200자 이하입니다.' }
              })}
              onChange={handleChange}
            />
            {kind.toUpperCase() !== 'SECRET' && kind.toUpperCase() !== 'NOTICE' && (
              <FormControlLabel control={<Checkbox />} id="isSecret" name="isSecret" label="비밀글" onChange={handleChangeCheckbox} checked={datas.isSecret} sx={{ ml: 1 }} />
            )}
            {authUtils.useIsAdmin() && kind.toUpperCase() !== 'NOTICE' && <FormControlLabel control={<Checkbox />} id="isSecret" name="isNotice" label="공지사항" onChange={handleChangeCheckbox} checked={datas.isNotice} />}
            {kind.toUpperCase() === 'NOTICE' && (
              <Stack direction="row" spacing={1} sx={{ ml: 1, mt: 1, width: 3.5 / 5 }}>
                <LocalizationProvider dateAdapter={DateAdapter}>
                  <DatePicker
                    inputFormat={'yyyy-MM-DD'}
                    value={startDate}
                    onChange={(newValue) => {
                      setStartDate(newValue);
                    }}
                    label="게시 시작일"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{ maxWidth: 200 }}
                        error={!!errors.startDate}
                        helperText={errors.startDate && errors.startDate.message}
                        {...register('startDate', {
                          required: '시작일 입력해주세요.'
                        })}
                      />
                    )}
                    disableMaskedInput={true}
                    disablePast={true}
                  />
                </LocalizationProvider>
                <Typography component="h1" variant="body1">
                  ~
                </Typography>
                <LocalizationProvider dateAdapter={DateAdapter}>
                  <DatePicker
                    inputFormat={'yyyy-MM-DD'}
                    value={endDate}
                    onChange={(newValue) => {
                      if (newValue < startDate) {
                        setError('endDate', { type: 'nonPast', message: '종료일이 시작일보다 빠를수 없습니다.' });
                        return;
                      }
                      setEndDate(newValue);
                    }}
                    label="게시 종료일"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{ maxWidth: 200 }}
                        error={!!errors.endDate}
                        helperText={errors.endDate && errors.endDate.message}
                        {...register('endDate', {
                          required: '종료일을 입력해주세요.'
                        })}
                      />
                    )}
                    disableMaskedInput={true}
                    disablePast={true}
                  />
                </LocalizationProvider>
              </Stack>
            )}
            <br />
            <Box component="div" sx={{ maxWidth: 1200, minHeight: 500, ml: 1, overflowY: 'auto' }}>
              <Editor previewStyle="vertical" height="800px" ref={editorRef} initialEditType={'wysiwyg'} plugins={[colorSyntax]} language={'ko-KR'} />
            </Box>
            <br />
            {!!file && (
              <Box component="div" sx={{ maxWidth: 1200, ml: 1, overflowY: 'auto' }}>
                <Dropzone id="file" maxFilesize={5242880} formData={formData} />
              </Box>
            )}
            {!!datas.files && (
              <Box>
                <TableContainer component={'div'}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <>
                            <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth, width: column.width }}>
                              {column.label}
                            </TableCell>
                            <TableCell></TableCell>
                          </>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {datas.files.map((row, rowIdx) => (
                        <TableRow hover key={row.id}>
                          {columns.map((col, colIdx) => (
                            <>
                              <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                                {row[col.id]}
                              </TableCell>
                              <TableCell key={`row${rowIdx}-down`} align="left">
                                <Tooltip title={`파일 삭제`}>
                                  <IconButton
                                    aria-label="down"
                                    onClick={(e) => {
                                      handleFileDelete(row.id);
                                    }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Tooltip>
                              </TableCell>
                            </>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
            <Button type="submit" sx={{ width: 200, ml: 1 }} variant="contained">
              {state === 'register' ? '등록' : state === 'modify' ? '수정' : '답글 등록'}
            </Button>
            <Button sx={{ width: 200, ml: 1 }} variant="contained" color={'warning'} onClick={handleBack}>
              취소
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}
